import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ViewChild,
  ChangeDetectorRef
} from "@angular/core";
import { TreeviewConfig} from "ngx-treeview";
import { TranslateService } from "@ngx-translate/core";
import {MonitoredTrain, TrainTypeConfiguration} from "../../models/monitored-train";

import {TreeNode, MenuItem} from "primeng/api";
import { OverlayPanel } from 'primeng/overlaypanel';
import {DevicePropertyVisibilityConfiguration, ProjectConfiguration} from "@/app/features/project/models/project-configuration";
import { Subscription } from 'rxjs';
import { TrainTreeStructurePipe } from '../../pipes/train-tree-structure.pipe';

@Component({
  selector: "app-train-tree-structure",
  template: require('./train-tree-structure.component.html'),
  styles: [require('./train-tree-structure.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainTreeStructureComponent implements OnInit {
  @Input() train: MonitoredTrain;
  @Input() projectConfiguration: ProjectConfiguration;
  @Input() trainTypeConfiguration: TrainTypeConfiguration;
  @Input() layout: string;
  @Output() select = new EventEmitter<any>();

  @ViewChild('op') op: OverlayPanel;
  //trainStructure: TreeItem[];
  node: any;

  selectedItems: TreeNode[];
  items: MenuItem[];

  trainTypeConfig: TrainTypeConfiguration;

  ipRemappingPort: any;

  config = TreeviewConfig.create({
    hasAllCheckBox: true,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: false,
    maxHeight: 400
  });

  languageChangeSubscription: Subscription;

  devicePropertyVisibilityConfigurations: DevicePropertyVisibilityConfiguration[];
  
  constructor(
    private translate: TranslateService,
    private trainTreeStructurePipe: TrainTreeStructurePipe,
    private cd: ChangeDetectorRef
  ) {
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.cd.detectChanges();
    })
  }

  ngOnInit(): void {

    this.devicePropertyVisibilityConfigurations = this.projectConfiguration && this.projectConfiguration.devicePropertyVisibilityConfigurations || [];
    const trainStructure: any[] = this.trainTreeStructurePipe.transform(this.train, this.trainTypeConfiguration);

      if (trainStructure.length > 0 && trainStructure) {
        this.selectedItems = [
          trainStructure[0],
          ...trainStructure[0].children,
          ...trainStructure[0].children ? trainStructure[0].children.reduce((acc: any, node) => {
            return [
              ...acc,
              ...node.children
            ];
          }, []) : []
        ];
      }
  }

  onSelectedChange = () => {};

  onFilterChange = () => {};

  onUnselect = () => {
    this.select.emit(this.selectedItems)
  };

  onSelect = () => {
    this.select.emit(this.selectedItems)
  };

  openDeviceConfiguration = (ev: Event, device: any, linkType: string) => {
    ev.stopPropagation();
    ev.preventDefault();
    window.open(`${linkType}://${device.surfIPAddress}`, "_blank");
  }

  onLeaveOverlay = () => {
    this.op.hide();
  }

}
